import Vue from 'vue';

const state = {
  highlightStates: {},
};

const getters = {
  highlightStates: state => state.highlightStates,
  get: state => (flashcardId, categoryId) => {
    const key = `${flashcardId}-category-${categoryId}`;
    return state.highlightStates[key];
  },
};

const mutations = {
  set: (state, highlightState) => {
    const { flashcardId, categoryId } = highlightState;
    const key = `${flashcardId}-category-${categoryId}`;
    const highlightStates = state.highlightStates[key] || [];
    highlightStates.push(highlightState);
    Vue.set(state.highlightStates, key, highlightStates);
  },
};

const actions = {
  set: ({ commit }, highlightState) => {
    commit('set', highlightState);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
